module.exports = __webpack_public_path__ + "static/media/JLU_Giessen-Logo.a23a0acc.svg";